var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"atabix-mfa-output"},[_c('div',{staticClass:"atabix-mfa-output__grid"},[_c('img',{staticClass:"atabix-mfa-output__image",attrs:{"alt":"MFA output","src":_vm.value.image}}),_c('v-icon',{staticClass:"atabix-mfa-output__button",on:{"click":_vm.onGenerateMfaTokenClick}},[_vm._v("refresh")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }